// Each file here is tied to the routes defined in the routes folder.
// All API calls originating from that page can be put here

/* eslint-disable no-undef */
import { generatePath } from 'react-router-dom';
import { axiosInstance } from '../common';

// Define all api endpoint urls at the top
const ENDPOINT_GENERAL = '/vendor/item/';


export const getProductionList = (payload) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL), { params: payload })
}

export const getProductionDetails = (id) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL + ':id', {
        id
    })).then(({ data }) => data)
}


export const getSample = (id) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL + ':id' + '/sample', {
        id
    })).then(({ data }) => data)
}


export const getArtwork = (id) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL + ':id' + '/artwork', {
        id
    })).then(({ data }) => data)
}


export const getDeliveryDetails = (id) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL + ':id' + '/delivery-details', {
        id
    })).then(({ data }) => data)
}
export const sendTemplate = (id, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + ':id' + '/sample', {
        id
    }), payload)
}

export const sendShippingDetails = (itemId, id, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/shipping/:id', {
        itemId,
        id
    }), payload)
}

export const sendShippingDetailsByVendor = (itemId, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/add-delivery-shipping-details', {
        itemId,
    }), payload)
}

export const sendOrderShippingDetailsByFile = (itemId, id, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/shipping/:id', {
        itemId,
        id
    }), payload).then(({ message }) => message)
}

export const confirmDelivery = (itemId, shipmentId, payload) => { // this will call when only Vendor confrims delivery
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/shipping/:id/confirm', {
        itemId,
        id: shipmentId
    }), payload)
}

export const confirmDeliveryByOnlyVendor = (itemId, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/delivery-shipping-confirm', {
        itemId,
    }), payload)
}

export const sendDispatchDate = (itemId, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/expected-dispatch-date', {
        itemId
    }), payload)
}

export const sendDispatchDateByOnlyVendor = (itemId, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + '/:itemId/add-delivery-expected-date', {    // this will call when only Vendor send dispatch date
        itemId,
    }), payload).then(({ message }) => message)
}


export const getDeliveredDetails = (ItemId, id) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL + '/:ItemId/delivered-proof/:id', {
        ItemId,
        id
    })).then(({ data }) => data)
}

export const sendArtWork = (id, payload) => {
    return axiosInstance.post(generatePath(ENDPOINT_GENERAL + ':id' + '/artwork', {
        id
    }), payload)
}


export const sendComment = (id, comment) => {
    return axiosInstance.post(generatePath('vendor/item/:id/erp-comment', {
        id
    }), {
        comment
    }).then(({ message }) => message)
}

export const getComments = (id) => {
    return axiosInstance.get(generatePath('vendor/item/:id/erp-comment', {
        id
    })).then(({ data }) => data)
}

export const getOrderDocuments = (id) => {
    return axiosInstance.get(generatePath(ENDPOINT_GENERAL+'/:id'+'/vendor-document-details', {
        id
    })).then(({ data }) => data)
}

// export const sendPrices = (id,payload) => {
//     return axiosInstance.post(generatePath(ENDPOINT_GENERAL+':id', {
//         id
//     }) ,payload )
// }

// export const sendPricesFile = (id,payload) => {
//     return axiosInstance.post(generatePath(ENDPOINT_GENERAL+':id'+'/file', {
//         id
//     }) ,payload )
// }

// export const requestVisual = (id,payload) => {
//     return axiosInstance.post(generatePath(ENDPOINT_GENERAL+':id'+'/visual-request', {
//         id
//     }) ,payload )
// }